import { TOAST_REQUIRED } from '../actions';

export default (state, action) => {
  if (!state) {
    return {
      required: false,
    };
  }

  switch (action.type) {
    case TOAST_REQUIRED:
      return {
        required: action.required,
      };
    default:
      break;
  }

  return state;
};
